module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin8-70b71b9576c34e2cd74b0746c078fa1f.jpg";